import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAdmins,
  PageAdmin,
} from '../pages/admins';
import {
  PageStudents,
} from '../pages/students';
import {
  PageOpens,
  PageOpen,
} from '../pages/opens';
import {
  PageCertificates,
} from '../pages/certificates';

const RouteUsers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/admins`} />
      </Route>
      <Route exact path={`${path}/admins`}>
        <PageAdmins />
      </Route>
      <Route exact path={`${path}/admins/:_id`}>
        <PageAdmin />
      </Route>
      <Route exact path={`${path}/students`}>
        <PageStudents />
      </Route>
      <Route exact path={`${path}/certificates`}>
        <PageCertificates />
      </Route>
      <Route exact path={`${path}/opens`}>
        <PageOpens />
      </Route>
      <Route exact path={`${path}/opens/:_id`}>
        <PageOpen />
      </Route>
    </Switch>
  );
};

export default RouteUsers;
